import { createApi } from '@reduxjs/toolkit/query/react';
import { ONE_DAY_SECONDS } from '../../constants';
import { Holiday, HolidaysParams } from '../../models/holidays';
import axiosBaseQuery from '../../services/api/axiosBaseQuery';

export const daysOffService = createApi({
  reducerPath: 'daysOffService',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getDaysOff: builder.query<Holiday[], HolidaysParams>({
      query: (params) => ({ url: '/api/DaysOff', params }),
      keepUnusedDataFor: ONE_DAY_SECONDS,
    }),
  }),
});

export const { useGetDaysOffQuery } = daysOffService;
